import { withStyles } from '@material-ui/core';
import PrintTable from './PrintTable';
import reportConstants from '../../../constants';
import { format } from 'date-fns';

const styles = {
  hideContainer: {
    display: 'none'
  }
};

const PrintComponent = ({ containerRef, printData, driverData, classes }) => {
  return (
    <div className={classes.hideContainer}>
      <PrintTable
        printRef={containerRef}
        printData={printData}
        driverNumber={driverData?.driverNumber}
        driverName={driverData?.text}
        dispatchDate={format(driverData?.dispatchDate, reportConstants.REPORT_DISPLAY_DATE_FORMAT)}
        terminalCode={driverData?.terminalCode}
      />
    </div>
  );
};

export default withStyles(styles)(PrintComponent);
